import React from "react";
import PrestoText from "@presto-components/PrestoText";

export default function ToggleBillDetailsText(props) {
  return <PrestoText {...props} />;
}
